import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
// @mui
import {
  Container, Typography, Stack, Button,
  Radio, RadioGroup, FormControlLabel, FormControl,
} from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { UserListToolbar } from '../sections/@dashboard/user';
import Iconify from '../components/iconify';
import AddProduto from './AddProduto';

// api
import { validateUser, getModulos, getInversores, getBaterias, getInversoresBomb,
         updateModulo, updateInversor, updateBateria, updateInversorBomb } from './api';
import config from '../config.json';

// ----------------------------------------------------------------------

export default function Produtos() {
  const [rows, setRows] = useState([]);
  const [radioValue, setRadioValue] = useState('modulos');
  const [filterValue, setFilterValue] = useState('');

  const navigate = useNavigate();
  useEffect(() => { validateuser(); }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };

  useEffect(() => { fetchData(); }, [radioValue]);

  const fetchData = async () => {
    try {
      let data = [];
      if (radioValue === 'modulos')        data = await getModulos();
      if (radioValue === 'inversores')     data = await getInversores();
      if (radioValue === 'baterias')       data = await getBaterias();
      if (radioValue === 'inversoresbomb') data = await getInversoresBomb();
      setRows(data || []);
    } catch (e) {
      window.alert('Erro ao consultar banco de dados');
    }
  };

  // Modal
  const [open, setOpen] = React.useState(false);
  const [produto, setProduto] = React.useState(null);

  const handleOpen = () => { setProduto(null); setOpen(true); };
  const handleClose = () => { setOpen(false); setProduto(null); };

  const handleDoubleClickTable = (row) => {
    setProduto({ ...row });
    setOpen(true);
  };

  const onConfirmHandler = async (updatedProduto) => {
    try {
      if (radioValue === 'modulos')        await updateModulo(updatedProduto);
      if (radioValue === 'inversores')     await updateInversor(updatedProduto);
      if (radioValue === 'baterias')       await updateBateria(updatedProduto);
      if (radioValue === 'inversoresbomb') await updateInversorBomb(updatedProduto);
    } catch (e) {
      window.alert('Erro ao salvar');
    }
    handleClose();
    fetchData();
  };

  const handleFilter = (e) => setFilterValue(e.target.value);

  const filtered = rows.filter((row) => {
    const v = filterValue.toLowerCase();
    return (
      row.modelo?.toLowerCase().includes(v) ||
      row.marca?.toLowerCase().includes(v) ||
      row.fabricante?.toLowerCase().includes(v)
    );
  });

  // Cabeçalhos por aba
  const headers = {
    modulos:        ['Modelo', 'Marca', 'Potência (Wp)', 'Ativo'],
    inversores:     ['Modelo', 'Fabricante', 'Potência (kW)', 'Ativo'],
    baterias:       ['Modelo', 'Fabricante', 'Potência (kW)', 'Autonomia (kWh)', 'Ativo'],
    inversoresbomb: ['Modelo', 'Fabricante', 'Potência (CV)', 'Ativo'],
  };

  const renderCells = (row) => {
    if (radioValue === 'modulos') return (
      <>
        <TableCell>{row.modelo}</TableCell>
        <TableCell>{row.marca}</TableCell>
        <TableCell align="center">{row.potencia}</TableCell>
        <TableCell align="center">{row.ativo ? 'Sim' : 'Não'}</TableCell>
      </>
    );
    if (radioValue === 'inversores') return (
      <>
        <TableCell>{row.modelo}</TableCell>
        <TableCell>{row.fabricante}</TableCell>
        <TableCell align="center">{row.potencia}</TableCell>
        <TableCell align="center">{row.ativo ? 'Sim' : 'Não'}</TableCell>
      </>
    );
    if (radioValue === 'baterias') return (
      <>
        <TableCell>{row.modelo}</TableCell>
        <TableCell>{row.fabricante}</TableCell>
        <TableCell align="center">{row.potencia}</TableCell>
        <TableCell align="center">{row.autonomia}</TableCell>
        <TableCell align="center">{row.ativo ? 'Sim' : 'Não'}</TableCell>
      </>
    );
    if (radioValue === 'inversoresbomb') return (
      <>
        <TableCell>{row.modelo}</TableCell>
        <TableCell>{row.fabricante}</TableCell>
        <TableCell align="center">{row.potencia}</TableCell>
        <TableCell align="center">{row.ativo ? 'Sim' : 'Não'}</TableCell>
      </>
    );
    return null;
  };

  return (
    <>
      <Helmet><title>Produtos</title></Helmet>
      <Container maxWidth="xl">
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h4">Produtos</Typography>
          <Button variant="contained" startIcon={<Iconify icon="zondicons:add-solid" />}
            onClick={handleOpen} sx={{ height: 50 }}>
            Adicionar
          </Button>
        </Stack>

        {/* Abas */}
        <FormControl sx={{ mb: 2 }}>
          <RadioGroup row value={radioValue} onChange={(e) => setRadioValue(e.target.value)}>
            <FormControlLabel value="modulos"        control={<Radio />} label="Módulos" />
            <FormControlLabel value="inversores"     control={<Radio />} label="Inversores" />
            <FormControlLabel value="baterias"       control={<Radio />} label="Baterias" />
            <FormControlLabel value="inversoresbomb" control={<Radio />} label="Inv. Bombeamento" />
          </RadioGroup>
        </FormControl>

        <UserListToolbar filterName={filterValue} onFilterName={handleFilter} sx={{ width: '80vw' }} />

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                {headers[radioValue].map((h) => (
                  <TableCell key={h} align={h === 'Modelo' || h === 'Marca' || h === 'Fabricante' ? 'left' : 'center'}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map((row, index) => (
                <TableRow key={index}
                  sx={{ '&:last-child td': { border: 0 }, '&:hover': { backgroundColor: 'Azure' }, cursor: 'pointer' }}
                  onDoubleClick={() => handleDoubleClickTable(row)}
                >
                  {renderCells(row)}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {open && (
        <AddProduto
          open={open}
          produto={produto}
          radioValue={radioValue}
          onClose={handleClose}
          onConfirm={onConfirmHandler}
        />
      )}
    </>
  );
}